/* Quick-add handler for .pc2026__quick buttons.
   Delegates from document so any number of grids on a page just work.
   Flow:
     1. Block the parent link click so we don't navigate.
     2. POST to /cart/add.js with the first available variant.
     3. Pop the React-style sidecart (window.PhilpsSidecart) — refresh
        it so the new line item is rendered, then open it. The sidecart
        also syncs the header bag count, so no manual bubble bump is
        needed when it's present.
     4. Fall back to Dawn's cart-notification / cart-drawer if the
        sidecart isn't on the page; otherwise bump the header bag count.
*/
(function () {
  if (window.__pc2026QuickAddBound) return;
  window.__pc2026QuickAddBound = true;

  function publishToSidecart() {
    if (!window.PhilpsSidecart) return Promise.resolve(false);
    var ops = [];
    if (typeof window.PhilpsSidecart.refresh === 'function') {
      ops.push(window.PhilpsSidecart.refresh());
    }
    return Promise.all(ops).then(function () {
      if (typeof window.PhilpsSidecart.open === 'function') {
        window.PhilpsSidecart.open();
      }
      return true;
    });
  }

  function publishToDawn(parsedResponse) {
    if (!parsedResponse) return false;
    var notification = document.querySelector('cart-notification');
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    if (notification && typeof notification.getSectionsToRender === 'function') {
      sections = sections.concat(notification.getSectionsToRender());
    }
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = sections.concat(drawer.getSectionsToRender());
    }
    if (sections.length === 0) return false;
    var url = '/?sections=' + sections.map(function (s) { return s.section; }).join(',');
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (sectionsData) {
        if (notification && typeof notification.renderContents === 'function') {
          parsedResponse.sections = sectionsData;
          notification.renderContents(parsedResponse);
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: sectionsData });
        }
        return true;
      })
      .catch(function () { return false; });
  }

  function bumpHeaderBag() {
    var bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return;
    var node = bubble.querySelector('span:first-child');
    if (!node) return;
    var current = parseInt(node.textContent || '0', 10);
    if (isNaN(current)) return;
    node.textContent = current + 1;
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.pc2026__quick');
    if (!btn) return;
    // `.pc2026__quick--view` is a "View product" pill on cards whose
    // products need a variant choice (Box size / flavours / etc.) —
    // it shares the visual but lets the click fall through to the
    // parent <a class="pc2026"> so the user lands on the product page.
    if (btn.classList.contains('pc2026__quick--view')) return;
    evt.preventDefault();
    evt.stopPropagation();
    if (btn.dataset.state === 'loading' || btn.dataset.state === 'added') return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalLabel = btn.textContent;
    btn.dataset.state = 'loading';
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw res.data;
        // Sidecart first (the React-style drawer used sitewide). If it's
        // not on the page, fall back to Dawn's notification/drawer
        // elements; if neither, just bump the header count manually.
        return publishToSidecart().then(function (handled) {
          if (handled) return;
          return publishToDawn(res.data).then(function (dawnHandled) {
            if (!dawnHandled) bumpHeaderBag();
          });
        });
      })
      .then(function () {
        btn.dataset.state = 'added';
        btn.textContent = 'Added';
        setTimeout(function () {
          btn.dataset.state = '';
          btn.textContent = originalLabel;
        }, 1500);
      })
      .catch(function (err) {
        console.error('[pc2026] quick-add failed', err);
        btn.dataset.state = '';
        btn.textContent = originalLabel;
      });
  });
})();
